import React from 'react';

const ChartBlackStonji: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="112" height="112" fill="#1D232A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 77.0349C24.866 77.0349 28 80.1689 28 84.0349L28 98.0349L14 98.0349L14 84.0349C14 80.1689 17.134 77.0349 21 77.0349Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.3335 56.0349C48.1995 56.0349 51.3335 59.1689 51.3335 63.0349L51.3335 98.0349L37.3335 98.0349L37.3335 63.0349C37.3335 59.1689 40.4675 56.0349 44.3335 56.0349Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.6665 63.0349C71.5325 63.0349 74.6665 66.1689 74.6665 70.0349L74.6665 98.0349L60.6665 98.0349L60.6665 70.0349C60.6665 66.1689 63.8005 63.0349 67.6665 63.0349Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91 42.0349C94.866 42.0349 98 45.1689 98 49.0349L98 98.0349L84 98.0349L84 49.0349C84 45.1689 87.134 42.0349 91 42.0349Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.2393 42.5708L74.6538 19.2374L78.1538 25.2996L37.7393 48.6329C36.0653 49.5994 33.9247 49.0259 32.9582 47.3519C31.9917 45.6778 32.5653 43.5373 34.2393 42.5708Z"
        fill="#00A868"
      />
      <path
        d="M79.4352 20.5185C80.4017 22.1925 79.8282 24.3331 78.1541 25.2996C76.4801 26.2661 74.3395 25.6925 73.373 24.0185C72.4065 22.3445 72.9801 20.2039 74.6541 19.2374C76.3282 18.2709 78.4687 18.8445 79.4352 20.5185Z"
        fill="#00A868"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.279 14.0565L77.3096 18.8878L75.4978 25.6493L57.4672 20.818C55.6001 20.3177 54.4921 18.3985 54.9924 16.5314C55.4927 14.6643 57.4118 13.5562 59.279 14.0565Z"
        fill="#00A868"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.9534 41.2051L79.7847 23.1744L73.0232 21.3627L68.1919 39.3933C67.6916 41.2605 68.7996 43.1796 70.6668 43.6799C72.5339 44.1802 74.4531 43.0722 74.9534 41.2051Z"
        fill="#00A868"
      />
    </svg>
  );
};

export default ChartBlackStonji;
